import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LoaderComponent } from '@dnhb/node_package';
import { dispatchMapper } from '../../../shared/wizard/actions';
import HnsLogoSvg from 'images/hns/logo.svg'

class OutputEmpty extends Component {
  render() {

    return (
      <div className="placeholder with-loader no-tablet-and-smaller">
        <div className="flex-container output-empty-content">
          { this.props.syncing ?
            <div className="flex-item">
              <LoaderComponent show /><br />
              <p>Laden</p>
            </div> :
            <div className="flex-item">
              <HnsLogoSvg className="logo" />
              <p>{ this.props.text }</p>
            </div>
          }
        </div>
      </div>
    );
  }
}

OutputEmpty.propTypes = {
  text: PropTypes.string.isRequired,
  syncing: PropTypes.bool.isRequired,
};

export default connect(state => ({
  syncing: state.syncing,
}), dispatchMapper)(OutputEmpty);
